import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { ShippingPaymentRoute } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ShippingPaymentRouteService extends TmsWebBaseEditService<ShippingPaymentRoute, ShippingPaymentRoute> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('ShippingPaymentRoute', $localize`Shipping Payment Route`);
  }
}
